import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { WhatsAppButton } from './WhatsAppButton';
import { SEO, pagesSEO } from '../shared/SEO';

export const Layout = ({ children }) => {
    const location = useLocation();
    const pathname = location.pathname.slice(1) || 'home'; // Remove leading slash
    const seoConfig = pagesSEO[pathname] || {};

    return (
        <div className="min-h-screen flex flex-col">
            <SEO 
                title={seoConfig.title}
                description={seoConfig.description}
                url={`https://aitrixy.com${location.pathname}`}
            />
            <Navbar />
            <main className="flex-1 pt-16 md:pt-20">
                {children}
            </main>
            <Footer />
            <WhatsAppButton />
        </div>
    );
};
